import React, { useEffect, useState, useMemo } from "react";
import { Col, Row, Card, CardBody, CardHeader } from "reactstrap";

import { ToastContainer } from 'react-toastify';

import { CardFrame } from "./CardFrame";
import 'assets/css/bus-utilization.css';

import { defaultBusHistory, defaultDensity, fetchDensity, fetchBusHistory, defaultUtilization, fetchUtilization, defaultPartials, fetchPartials, defaultSelected } from './helpers';
import { AllDensityChart, ByTerminalDensityChart } from './charts/densityChart';
import { AllUtilizationChart, ByTerminalUtilizationChart } from "./charts/UtilizationChart";
import { AllPartialsChart, ByTerminalPartialsChart } from "./charts/PartialsChart";
import { AllLossChart, ByTerminalLossChart } from "./charts/LossChart";
import { HistoryTable } from "./historyTable";
import ControlPanel from "./ControlPanel";

const BusUtilization = () => {
    const [density, setDensity] = useState(defaultDensity);
    const [history, setBusHistory] = useState(defaultBusHistory);
    const [utilization, setUtilization] = useState(defaultUtilization);
    const [partials, setPartials] = useState(defaultPartials);
    const [selected, setSelected] = useState(defaultSelected);

    useEffect(() => {
        (async () => {
            const data = await fetchDensity(selected);
            setDensity(data);
        })();
        (async () => {
            const data = await fetchBusHistory(selected);
            setBusHistory(data);
        })();
        (async () => {
            const data = await fetchUtilization(selected);
            setUtilization(data);
        })();
        (async () => {
            const data = await fetchPartials(selected);
            setPartials(data);
        })();
    }, [selected]);

    const memoizedControlPanel = useMemo(() => {
        return <ControlPanel selected={selected} setSelected={setSelected} />;
    }, []);

    const graphData = [
        { Graph: AllLossChart(utilization), Title: "All Terminals Weight and Length Daily Waste" },
        { Graph: ByTerminalLossChart(utilization), Title: "By Terminal Weight and Length Daily Waste" },
        { Graph: AllDensityChart(density), Title: "All Terminals Bus and Order Daily Density" },
        { Graph: ByTerminalDensityChart(density), Title: "By Terminal Bus and Order Daily Density" },
        { Graph: AllUtilizationChart(utilization), Title: "All Terminals Weight and Length Daily Utilization" },
        { Graph: ByTerminalUtilizationChart(utilization), Title: "By Terminal Weight and Length Daily Utilization" },
        { Graph: AllPartialsChart(partials), Title: "All Terminals Partials and Orders with Partials" },
        { Graph: ByTerminalPartialsChart(partials), Title: "By Terminal Partials and Orders with Partials" }
      ];
      
    return (
        <>
            <ToastContainer />
            <Row>
                <Col>
                <Card className="shadow rounded">
                    <CardHeader className="bg-dark text-white">Bus Utilization Control Panel</CardHeader>
                    <CardBody>
                    <div className="">
                        {memoizedControlPanel}
                    </div>
                    </CardBody>
                </Card>
                </Col>
            </Row>
            <Row>
                {graphData.map((item, index) => (
                    <Col lg={6} md={12} key={index}>
                        <CardFrame Graphs={graphData} GraphIndex={index} />
                    </Col>
                ))}
            </Row>
            <Row>
                <Col>
                    <HistoryTable history={history}/>
                </Col>
            </Row>
        </>            
    );
};

export default BusUtilization;